import unitOfWork from '@controllers';

const submitForm = ({
  user,
  shipService,
  setToastMessage,
  fetchShipServices,
  closeEditButton,
}) => {
  if (shipService.id) {
    unitOfWork.shipService.update({
      user,
      shipService,
      setToastMessage,
      fetchShipServices,
      closeEditButton,
    });
  } else {
    unitOfWork.shipService.create({
      user,
      shipService,
      setToastMessage,
      fetchShipServices,
      closeEditButton,
    });
  }
};

const event = {
  submitForm,
};
export default event;
